import { IFeed } from 'homepage/types/Feed';
import { bugsnag } from 'shared/utils/services/bugsnag';

export const CACHE_MAP = 'GOAT.homepage-data-and-scroll-cache';

interface ICacheMapItem {
  currentFeed: IFeed[];
  pastScrollPositions: number[];
}

/**
 * [homepageDataCache]
 * initializes, reads, and writes the cache that is used to preserve
 * the homepage scroll position, and previously requested items
 */

export const homepageDataCache = {
  initialize: () => {
    try {
      const cache: ICacheMapItem | { currentFeed: []; pastScrollPositions: [] } = JSON.parse(
        window.sessionStorage.getItem(CACHE_MAP),
      );

      if (cache) return;

      window.sessionStorage.setItem(
        CACHE_MAP,
        JSON.stringify({ currentFeed: [], pastScrollPositions: [] }),
      );
    } catch (error) {
      bugsnag(error, { context: 'HomepageDataAndPositionCache initialize' });
    }
  },
  read: () => {
    try {
      const cache: ICacheMapItem | { currentFeed: []; pastScrollPositions: [] } = JSON.parse(
        window.sessionStorage.getItem(CACHE_MAP),
      );
      const cachedScrollPosition = cache?.pastScrollPositions?.pop();
      const cachedFeed = cache?.currentFeed?.pop();
      window.sessionStorage.setItem(`${CACHE_MAP}`, JSON.stringify(cache));
      return { cachedScrollPosition, cachedFeed };
    } catch (error) {
      bugsnag(error, { context: 'HomepageDataAndPositionCache read' });
    }
  },
  write: ({ scrollPosition, currentFeed }: { scrollPosition: number; currentFeed: IFeed }) => {
    try {
      const cacheMap: ICacheMapItem = JSON.parse(window.sessionStorage.getItem(CACHE_MAP)) || {};

      if (cacheMap?.pastScrollPositions?.length >= 1) {
        cacheMap?.pastScrollPositions?.shift();
      }

      if (
        cacheMap?.pastScrollPositions?.length > 0 ||
        cacheMap?.pastScrollPositions?.length === 0
      ) {
        cacheMap?.pastScrollPositions?.push(scrollPosition);
      }

      if (!cacheMap?.pastScrollPositions) {
        cacheMap.pastScrollPositions = [scrollPosition];
      }

      if (cacheMap?.currentFeed?.length >= 1) {
        void cacheMap?.currentFeed?.shift();
      }

      if (cacheMap?.currentFeed?.length > 0 || cacheMap?.currentFeed?.length === 0) {
        cacheMap?.currentFeed?.push(currentFeed);
      }

      if (!cacheMap?.currentFeed) {
        cacheMap.currentFeed = [currentFeed];
      }

      // TODO: Cache gets bigger than the capacity allowed for sessionstorage

      window.sessionStorage.setItem(CACHE_MAP, JSON.stringify(cacheMap));
    } catch (error) {
      bugsnag(error, { context: 'HomepageDataAndPositionCache write' });
    }
  },
};
